var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1894_15842)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87432 0.0748474L-0.0166016 5.77754C0.048853 10.8977 3.87796 16.6377 8.84159 19.0161C8.90223 19.0438 8.96831 19.0582 9.03522 19.0582C9.10212 19.0582 9.16821 19.0438 9.22884 19.0161C10.8449 18.2489 12.2944 17.1828 13.4974 15.8766C13.5 15.8738 13.5026 15.8709 13.5052 15.8681V15.8841C13.508 15.8813 13.5107 15.8785 13.5135 15.8757C16.279 13.0314 17.7055 8.27637 18.0161 5.82564L11.3234 1.37358L9.37613 0.0748474C9.3018 0.0263589 9.2145 0.000488281 9.12521 0.000488281C9.03592 0.000488281 8.94864 0.0263589 8.87432 0.0748474ZM9.10875 2.30053L10.2137 3.03747L15.8196 6.76654C15.6149 7.6942 15.2879 8.81387 14.8267 9.96453C14.1391 11.6802 13.21 13.3214 12.0729 14.4883L13.2143 15.6006L12.0329 14.5145C11.1718 15.4511 10.1611 16.245 9.04039 16.8656C7.18791 15.8214 5.50482 14.2079 4.23837 12.3135C3.05563 10.5442 2.29738 8.62267 2.06141 6.82073L9.10875 2.30053Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1894_15842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19.0588,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldOutline);
export default __webpack_public_path__ + "static/media/shield-outline.9449a1b49c37eaa3e50a22e3ec773c4c.svg";
export { ForwardRef as ReactComponent };